import * as types from './types';

export default { [types.SET_SESSION_EXPIRE_DATE]: (state, expireDate) => state.expireDate = expireDate };
